import Vue from "vue";
import VueRouter from "vue-router";

// Pages
import Dashboard from "@/pages/Dashboard.vue";
import AccesoDenegado from "@/pages/AccesoDenegado.vue";
import PaginaNoEncontrada from "@/pages/PaginaNoEncontrada.vue";
import CerrandoSesion from "@/pages/CerrarSesion.vue";
// Modulos de rutas
import depositoRoutes from "@/router/depositoRoutes";
import actuacionRoutes from "@/router/actuacionesRoutes";
import parametrizacionRoutes from "@/router/parametrizacionRoutes";
import Location from "@/pages/Location.vue";
import Notifications from "@/pages/Notifications.vue";
import Contrasenia from "@/pages/Contrasena.vue";
import BibliotecaVirtual from "@/pages/BibliotecaVirtual.vue";
import NewActuacion from "@/pages/NewActuacion.vue";
import Calabozo from "@/pages/Calabozo.vue";
import Sifcop from "@/pages/Sifcop.vue";
import SifcopDigitized from "@/pages/SifcopDigitized.vue";
import SifcopDetailView from "@/pages/SifcopDetailView.vue";
import ImagenCompresionPrueba from "@/pages/ImagenCompresionPrueba.vue";
import {
  isDesktopRolGuard,
  calaboceroGuard,
  isUserRolGuard,
  notificationsGuard,
  sifcopGuard,
  stepGuard,
  imagenesGuard,
} from "@/guards/index";

Vue.use(VueRouter);

// Pages
const routes = [
  {
    path: "/",
    name: "escritorio",
    component: Dashboard,
    props: { pageTitle: "ESCRITORIO" },
    beforeEnter: isDesktopRolGuard,
  },
  {
    path: "/deposito",
    name: "deposito-efectos",
    ...depositoRoutes,
  },
  {
    path: "/actuaciones",
    beforeEnter: isUserRolGuard,
    ...actuacionRoutes,
  },
  {
    path: "/parametrizacion",
    // beforeEnter: isUserRolGuard,
    redirect: "/parametros",
  },
  {
    path: "/parametros",
    name: "parametros",
    // beforeEnter: isUserRolGuard,
    ...parametrizacionRoutes,
  },
  {
    path: "/location",
    name: "localizacion",
    component: Location,
  },
  {
    path: "/notificaciones",
    name: "notificaciones",
    component: Notifications,
    beforeEnter: notificationsGuard,
  },
  {
    path: "/calabozo",
    name: "calabozo",
    component: Calabozo,
    beforeEnter: calaboceroGuard,
  },
  {
    path: "/subida-imagenes",
    name: "subida-imagenes",
    component: ImagenCompresionPrueba,
    beforeEnter: imagenesGuard,
  },
  {
    path: "/sifcop",
    name: "sifcop",
    component: Sifcop,
    beforeEnter: sifcopGuard,
  },
  {
    path: "/sifcop/new",
    name: "sifcop-new",
    component: SifcopDigitized,
    beforeEnter: sifcopGuard,
  },
  {
    path: "/sifcop/:id",
    name: "sifcop-detail",
    component: SifcopDetailView,
    beforeEnter: sifcopGuard,
  },
  {
    path: "/editar-contrasena",
    name: "cambiar-contraseña",
    component: Contrasenia,
  },
  { path: "/bibliotecaVirtual", name: "bibliotecaVirtual", component: BibliotecaVirtual },
  {
    path: "/newActuacion",
    component: NewActuacion,
    beforeEnter: stepGuard,
    children: [
      { path: "", redirect: (to) => ({ path: "/newActuacion/afectados", query: to.query }) },
      {
        path: "datos",
        name: "newActuacion-datos",
        component: () => import("@/pages/newActuacion/StepDatosLegales.vue"),
      },
      {
        path: "afectados",
        name: "newActuacion-afectados",
        component: () => import("@/pages/newActuacion/StepAfectados.vue"),
      },
      {
        path: "vinculados",
        name: "newActuacion-vinculados",
        component: () => import("@/pages/newActuacion/StepVinculados.vue"),
      },
      {
        path: "fecha-hora-ubicacion",
        name: "newActuacion-fecha",
        component: () => import("@/pages/newActuacion/StepFechaHoraUbicacion.vue"),
      },
      {
        path: "efectos",
        name: "newActuacion-efectos",
        component: () => import("@/pages/newActuacion/StepEfectos.vue"),
      },
      {
        path: "personal-interviniente",
        name: "newActuacion-personal-interviniente",
        component: () => import("@/pages/newActuacion/StepPersonalInterviniente.vue"),
      },
      {
        path: "afectacion-patrimonial",
        name: "newActuacion-afectacion-patrimonial",
        component: () => import("@/pages/newActuacion/StepAfectacionPatrimonial.vue"),
      },
      {
        path: "visualizacion-acta",
        name: "newActuacion-visualizacion",
        component: () => import("@/pages/newActuacion/StepVisualizacionActa.vue"),
      },
    ],
  },
  { path: "/acceso-denegado", AccesoDenegado, component: AccesoDenegado },
  { path: "/logout", name: "cerrando-sesion", component: CerrandoSesion },
  { path: "/:pathMatch(.*)*", name: "not-found", component: PaginaNoEncontrada },
];

const router = new VueRouter({
  routes,
  mode: "history",
});
router.afterEach((to, from) => {
  const fromRoute = from.path;
  const toRoute = to.path;
  if (Vue.prototype.$isOffline) {
    if (fromRoute.startsWith("/actuaciones/new/") && toRoute.startsWith("/actuaciones/new/")) {
      return; // No hacemos nada, evitamos ejecutar el modal
    }
    document.dispatchEvent(new CustomEvent("sw-offline-detected"));
    // Reiniciamos la variable para evitar que se vuelva a disparar
    Vue.prototype.$isOffline = false;
  }
});

export default router;
